export function defaultCollab(patch = {}) {
  return {
    brand: '',
    brandLogoUrl: '',
    campaign: '',
    description: '',
    type: 'Paid campaign',
    startDate: '',
    endDate: '',
    status: 'Planned',
    paymentType: 'Paid',
    compensation: '',
    currency: 'SGD',
    visibility: 'Public',
    deliverables: [],
    ...patch,
  };
}
